<p class="text-center {{data.status === true ? 'custom-title-message-blue' : 'custom-title-message-danger' }}">Bạn đang thực hiện cập nhật trạng thái năm học</p>
<p class="text-center custom-show-name">{{data.infoSchoolYear.fullname}} ({{data.infoSchoolYear.code}})</p>
<br>
<p class="custom-message text-center">Bạn có thay đổi thực hiện này không ?</p>
<p class="text-center">
    <button mat-dialog-close class="btn btn-close-custom">Hủy</button>&nbsp;&nbsp;
    <button class="btn btn-add" (click)="confirmStatus()">Xác nhận</button>
</p>
